import React from "react";
import { formatBytes, numberToMoney, numberToUSD } from "../../helpers/utils";


export const getGridColumns = (handleSort = () => { }, toggleDetailModal) => {

    const formatStorageQuota = (amount) => {
        if (!amount)
            return 0;
        if (amount === -1)
            return "Unlimited";
        return formatBytes(amount);
    }

    const formatStorageUsed = (amount) => {
        if (!amount)
            return 0;
        return formatBytes(amount);
    }


    const renderUser = (row) => {
        return (
            <div id={row.id}>
                <div><b>{row.fullname}</b></div>
                <div>{row.email}</div>
                {row?.activatedOn && <div><small>Activated on </small> <span className="font-weight-bold">{row?.activatedOn} {row?.enabled ? "" : "(disabled)"}</span></div>}
                {row?.lastActivityOn && <div><small>Last login on </small><span className="font-weight-bold">{row?.lastActivityOn}</span></div>}
                {row?.country && <div><small>Country: </small><span className="font-weight-bold">{row?.country}</span></div>}
            </div>
        );
    }

    const renderPlans = (row) => {
        if (row?.subsPlanName)
            return (
                <div>
                    <div ><b>{row?.subsPlanName}</b> ({row.subscribedOn}) </div>
                    {row?.addonPlanName && <div >{row?.addonPlanName} ({row?.addOnSubscribedOn})</div>}
                    {row?.addonPlanName2 && <div >{row?.addonPlanName2} ({row?.addOnSubscribedOn2})</div>}
                </div>
            );
        return null;
    }

    const renderSubscriptionCost = (row) => {
        if (row?.totalSubsCost && row?.totalSubsCost > 0) {
            const overdueAmount = row?.totalOveduePayment ? row?.totalOveduePayment : 0;
            const classNames = overdueAmount > 0 ? "font-weight-bold text-danger" : "";
            return (
                <div>
                    <div className="font-weight-bold cursor-pointer text-primary" onClick={() => toggleDetailModal(row?.id, 'SUBS_PAYMENTS', "Subscription Costs")}>${row?.totalSubsCost}</div>
                    <div><small>overdue: </small><span className={classNames}>{overdueAmount > 0 ? numberToUSD(overdueAmount) : 0}</span></div>
                </div>
            );
        }
        return null;
    }

    const renderOrders = (row) => {
        if (row?.orderTotal || row?.orderCanceled)
            return (
                <div>
                    {row?.orderTotal &&
                        <div title="Succeeded orders">
                            <small>Succ: </small><span className="cursor-pointer font-weight-bold text-primary text-right" onClick={() => toggleDetailModal(row?.id, 'ORDER_SUCCEEDED', "Successful orders")}>{numberToUSD(row.orderTotal)}</span>
                        </div>}
                    {row?.orderCanceled &&
                        <div title="Canceled orders" >
                            <small>Cxl: </small><span className="cursor-pointer font-weight-bold text-danger text-right" onClick={() => toggleDetailModal(row?.id, 'ORDER_CANCELED', "Canceled orders")}>{numberToUSD(row?.orderCanceled)}</span>
                        </div>}
                </div>
            )
        return null;
    }

    const renderStorage = (row) => {
        const exceeded = row?.maxStorageSize < 0 ? false : row?.currentStorageSize > row?.maxStorageSize;
        const classNames = "font-weight-bold " + (exceeded ? "text-danger" : "");
        return (
            <div>
                <div><span className={classNames}>{formatStorageUsed(row?.currentStorageSize)}</span></div>
                <div><small>max: </small><span className="font-weight-bold">{formatStorageQuota(row?.maxStorageSize)}</span></div>
            </div>
        )
    }

    const renderCredits = (row) => {
        if (row?.creditsBalance >= 0)
            return (
                <div>
                    <div><b>{row?.creditsBalance}</b></div>
                    <div><small>earned: </small><span className="cursor-pointer font-weight-bold text-primary" onClick={() => toggleDetailModal(row?.id, 'CREDITS_IN', "Credit Bundle Purchases")}>{row?.creditsEarned || 0}</span> </div>
                    <div><small>spent: </small><span className="cursor-pointer font-weight-bold text-primary" onClick={() => toggleDetailModal(row?.id, 'CREDITS_OUT', "Credits spent")}>{row?.creditsSpent || 0}</span> </div>
                </div>
            );
        return null;
    }

    const renderRevenue = (row) => {
        if (row?.revenueTotal && row?.revenueTotal > 0)
            return (
                <div>
                    <div title="Total revenue" className="cursor-pointer font-weight-bold text-primary" onClick={() => toggleDetailModal(row?.id, 'REVENUE_TOTAL', "All monthly revenues")}>{numberToUSD(row?.revenueTotal)}</div>
                    {row?.revenueTransfered && <div><small>paid: </small><span className="cursor-pointer font-weight-bold text-primary" onClick={() => toggleDetailModal(row?.id, 'REVENUE_PAID', "Transferred monthly revenues")}>{row?.revenueTransfered ? numberToUSD(row?.revenueTransfered) : 0}
                    </span></div>}
                </div>
            );
        return null;
    }

    const renderVideoCounts = (type, row) => {
        let totalCount = 0;
        let published = 0;
        if (type === 'COURSES') {
            totalCount = row?.courseCount || 0;
            published = row?.coursePublishedCount || 0;
        } else if (type === 'VIDEOS') {
            totalCount = row?.videoCount || 0;
            published = row?.videoPublishedCount || 0;
        } else if (type === 'SEEDS') {
            totalCount = row?.seedCount || 0;
            published = row?.seedPublishedCount || 0;
        } else if (type === 'HOTS') {
            totalCount = row?.hotCount || 0;
            published = row?.hotPublishedCount || 0;
        }

        if (totalCount == 0)
            return null;

        return (
            <div>
                <div><b>{totalCount}</b></div>
                <div><small>pub.: </small><b>{published}</b></div>
            </div>
        );

    }    

    const renderResource = (row) => {
        if (row?.resourceCount && row?.resourceCount > 0)
            return (
                <div>
                    <div><b>{row?.resourceCount}</b></div>
                    <div><small>published: </small><b>{row?.publishedResourceCount}</b></div>
                </div>
            );
        return null;
    }


    return [
        {
            dataField: "USER",
            text: "User",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderUser(row)
            ,
            headerStyle: () => {
                return { width: '200px' };
            },
        },
        {
            dataField: "PLAN",
            text: "Plans",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderPlans(row)
            ,
            headerStyle: () => {
                return { width: '120px' };
            },
        },
        {
            dataField: "SUBSCOST",
            text: "Subscription cost",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderSubscriptionCost(row),
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "ORDER",
            text: "Orders",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderOrders(row),
            headerStyle: () => {
                return { width: '120px' };
            },
        },
        {
            dataField: "STORAGE",
            text: "Storage",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderStorage(row),
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "CBALANCE",
            text: "Credits balance",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderCredits(row)
            ,
            headerStyle: () => {
                return { width: '120px' };
            },
        },
        {
            dataField: "REVENUE",
            text: "Revenue",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderRevenue(row)
            ,
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "COURSES",
            text: "Courses",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderVideoCounts('COURSES', row)
            ,
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "VIDEOS",
            text: "Videos",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderVideoCounts('VIDEOS', row),
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "SEEDS",
            text: "Seeds",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderVideoCounts('SEEDS', row)
            ,
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "HOTS",
            text: "HoTs",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderVideoCounts('HOTS', row)
            ,
            headerStyle: () => {
                return { width: '100px' };
            },
        },
        {
            dataField: "RESOURCES",
            text: "Resources",
            sort: true,
            onSort: (field, order) => {
                handleSort(field, order);
            },
            formatter: (_, row) => renderResource(row)
            ,
            headerStyle: () => {
                return { width: '120px' };
            },
        },
    ]
}
